import React, { useEffect, useState } from "react";
import { Box } from "@material-ui/core";
import { Container } from "@material-ui/core";
import { FormattedMessage, useIntl } from "react-intl";
import { FormikHelpers, useFormik } from "formik";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";

import { PageTitle } from "../../components/page-title/PageTitle";
import { SignupLayout } from "../../common/SignupLayout";
import { useStyles } from "./CheckInvitationCodeScreen.style";
import { Overlay } from "../../components/overlay/Overlay";
import { InputField } from "../../components/input-field/InputField";
import { InputButton } from "../../components/input-button/InputButton";
import { useQuery } from "../../common/Hooks";
import { LoadingStateAAttributes } from "../../attributes/base-attributes";
import BusinessBranchService from "../../services/BusinessBranchService";
import BusinessBranch from "../../models/BusinessBranch";
import { AddBranchManagerResponseAttributes } from "../../attributes/branch-manager-attributes";
import BranchManagerService from "../../services/BranchManagerService";
import { SlideWrapper } from "../../components/slide-wrapper/SlideWrapper";
import {
  useAuthenticationContext,
  UserActionTypeEnum,
} from "../../context/UserContext";
import { HomeScreen } from "../home/HomeScreen";

export const CheckInvitationCodeScreen = (props: any) => {
  const history = useHistory();
  const classes = useStyles(props);
  const intl = useIntl();
  const queryParams = useQuery();
  const branchId = queryParams.get("id");
  // State
  const [loading, setLoading] = useState(
    (): LoadingStateAAttributes => LoadingStateAAttributes.progress
  );
  // Context
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [user, token, authDispatch] = useAuthenticationContext();

  function checkBranch() {
    const response = BusinessBranchService.checkById(branchId);

    response.then((response) => {
      let branch: BusinessBranch | null = null;

      if (response.isSuccess) {
        switch (response.data.code) {
          case 100:
            branch = BusinessBranch.fromJson(
              JSON.parse(JSON.stringify(response.data.data))
            );
            formik.values.business_branch_id = branch.id;
            setLoading(LoadingStateAAttributes.success);
            break;
          case 101:
            setLoading(LoadingStateAAttributes.failure);
            break;
        }
      } else {
        setLoading(LoadingStateAAttributes.failure);
      }
    });
  }

  const formik = useFormik({
    initialValues: {
      business_branch_id: "",
      team_invitation_code: "",
    },
    validationSchema: Yup.object().shape({
      team_invitation_code: Yup.string().required(
        intl.formatMessage({ id: "error.enterValidInvitationCode" })
      ),
    }),
    onSubmit: async (
      values: AddBranchManagerResponseAttributes,
      { setErrors, setSubmitting }: FormikHelpers<any>
    ) => {
      try {
        const response = await BranchManagerService.add(formik.values);
        setSubmitting(false);

        if (response.isSuccess) {
          switch (response.data.code) {
            case 100: // Ok
              authDispatch({
                type: UserActionTypeEnum.addBranch,
                data: JSON.parse(JSON.stringify(response.data.data)),
              });
              history.replace(HomeScreen.routeName);
              break;
            case 150: // Validation error
              setErrors(JSON.parse(JSON.stringify(response.data.data)));
              break;
            case 102: // Unknown error
              setErrors({ unknown: response.data.message });
              break;
            case 101: // Error
              setErrors(JSON.parse(JSON.stringify(response.data.data)));
              break;
          }
        } else {
          setErrors({
            unknown: intl.formatMessage({ id: "sharedScreen.unknownError" }),
          });
        }
      } catch (err) {
        setSubmitting(false);
        setErrors({
          unknown: intl.formatMessage({ id: "sharedScreen.unknownError" }),
        });
      }
    },
  });

  const renderError = () => {
    if (formik.errors.unknown) {
      return formik.errors.unknown as string;
    }

    if (formik.errors.business_branch_id) {
      return formik.errors.business_branch_id as string;
    }

    if (loading === LoadingStateAAttributes.failure) {
      return intl.formatMessage({ id: "sharedScreen.unknownBranch" });
    }

    return "";
  };

  useEffect(() => {
    checkBranch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <PageTitle
        title={intl.formatMessage({ id: "sharedScreen.checkInvitationCode" })}
      />
      <SignupLayout mode="dark">
        <Box className={classes.root}>
          <Container maxWidth="xs" className={classes.outerWrapper}>
            <Box className={classes.outerWrapperInner}>
              <Container maxWidth="xs" className={classes.contentWrapper}>
                <SlideWrapper>
                  <Box className={classes.inputWrapper}>
                    <Box
                      marginBottom={2}
                      component="span"
                      className="title"
                      textAlign="center"
                    >
                      <FormattedMessage id="sharedScreen.invitationCode" />
                    </Box>
                    <Box component="span" className="subTitle">
                      <FormattedMessage id="sharedScreen.typeInvitationCode" />
                    </Box>
                    <Box component="div" mt={4}>
                      <InputField
                        id="team_invitation_code"
                        name="team_invitation_code"
                        fullWidth
                        autoFocus
                        label=""
                        placeholder=""
                        type="text"
                        value={formik.values.team_invitation_code}
                        onChange={formik.handleChange}
                        error={Boolean(formik.errors.team_invitation_code)}
                        helperText={
                          formik.errors.team_invitation_code as string
                        }
                      />
                    </Box>
                    {formik.errors ||
                    loading === LoadingStateAAttributes.failure ? (
                      <Box
                        mt={2}
                        mb={4}
                        component="div"
                        className="errorWrapper"
                        textAlign="center"
                      >
                        {renderError()}
                      </Box>
                    ) : (
                      <></>
                    )}

                    <Box component="div" mt={4}>
                      <InputButton
                        color="secondary"
                        fullWidth
                        size="medium"
                        variant="contained"
                        onClick={(_) => formik.handleSubmit()}
                      >
                        <FormattedMessage id="sharedScreen.continue" />
                      </InputButton>
                    </Box>
                  </Box>
                </SlideWrapper>
                <Overlay
                  loading={
                    loading === LoadingStateAAttributes.progress ||
                    formik.isSubmitting
                  }
                />
              </Container>
            </Box>
          </Container>
        </Box>
      </SignupLayout>
    </>
  );
};

CheckInvitationCodeScreen.routeName = "/invitation-code";
